import {animate, style, transition, trigger} from '@angular/animations';

/*
* Анимация плавного появления и скрытия.
* */

export const FadeInOutAnimation = trigger('fadeInOut', [
    transition(':enter', [
        style({opacity: 0}),
        animate(200)
    ]),
    transition(':leave', [
        animate(200,  style({opacity: 0}))
    ])
]);

export const FadeInAnimation = trigger('fadeIn', [
    transition(':enter', [
        style({opacity: 0}),
        animate('{{timeout}}ms')
    ], {params : {timeout: 200}}),
]);

export const FadeOutAnimation = trigger('fadeOut', [
    transition(':leave', [
        animate('{{timeout}}ms',  style({opacity: 0})),
    ], {params : {timeout: 200}})
]);
